var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.83331 5.46471H9.16665V6.79805H7.83331V5.46471ZM7.83331 8.13138H9.16665V12.1314H7.83331V8.13138ZM8.49998 2.13138C4.81998 2.13138 1.83331 5.11804 1.83331 8.79805C1.83331 12.478 4.81998 15.4647 8.49998 15.4647C12.18 15.4647 15.1666 12.478 15.1666 8.79805C15.1666 5.11804 12.18 2.13138 8.49998 2.13138ZM8.49998 14.1314C5.55998 14.1314 3.16665 11.738 3.16665 8.79805C3.16665 5.85805 5.55998 3.46471 8.49998 3.46471C11.44 3.46471 13.8333 5.85805 13.8333 8.79805C13.8333 11.738 11.44 14.1314 8.49998 14.1314Z",
    fill: "#0899DF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b06163f1e1aa47b3450e2b5aebcf16c7.svg";
export { ForwardRef as ReactComponent };